import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Image } from '@openedx/paragon';
import PropTypes from 'prop-types';

import { useT } from '../../../context/LanguageContext';

const SmallLayout = ({ fullName }) => {
  const { t } = useT();

  return (
    <div className="min-vw-100 bg-light-200">
      <div className="col-md-12 small-screen-top-stripe" />
      <a href="/">
        <Image className="logo-small" alt={getConfig().SITE_NAME} src={getConfig().LOGO_URL} />
      </a>
      <div className="d-flex align-items-center m-3.5">
        <div className="small-yellow-line mt-4.5" />
        <div>
          <h1 className="h5 data-hj-suppress">
            {t('welcome.to.platform', { siteName: getConfig().SITE_NAME, fullName })}
          </h1>
          <h2 className="h1">
            {t('complete.your.profile.1')}
            <div className="text-accent-a">
              {t('complete.your.profile.2')}
            </div>
          </h2>
        </div>
      </div>
    </div>
  );
};

SmallLayout.propTypes = {
  fullName: PropTypes.string.isRequired };

export default SmallLayout;
